import { Button, Typography } from "@hellocarbo/lasagne";
import { Check, Edit2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import Card from "@/components/ui/Card";
import { TTrajectoryAction } from "@/types";

import ActionListItem from "./ActionListItem";

type ActionsListProps = {
  isInEdition?: boolean;
  onEditionChange: (isInEdition: boolean) => void;
  actions: Array<TTrajectoryAction>;
};

function ActionsList({
  isInEdition = false,
  onEditionChange,
  actions,
}: ActionsListProps) {
  const { t, i18n } = useTranslation(["trajectory"]);

  return (
    <Card>
      <div className="mb-sm flex items-center justify-between">
        <Typography as="h2" step="2" weight="bold">
          {t("trajectory:actionPlan.actionPlan")}
        </Typography>
        <Button
          shape="soft"
          intent="secondary"
          size="small"
          onClick={onEditionChange}
          PrefixIcon={isInEdition ? Check : Edit2}
        >
          {t(`common:${isInEdition ? "validate" : "modify"}`)}
        </Button>
      </div>
      {actions.length ? (
        <ul className="gap-y-xs flex flex-col">
          {actions.map((action) => {
            const title =
              i18n.language === "en" ? action.title_en : action.title_fr;
            const content =
              i18n.language === "en" ? action.content_en : action.content_fr;

            return (
              <ActionListItem
                {...action}
                key={action.id}
                title={title}
                content={content}
                isReadOnly={!isInEdition}
                actionId={action.id}
              />
            );
          })}
        </ul>
      ) : (
        <div className="border-grayscale-xx-light p-sm rounded-lg border text-center">
          <Typography step="-1" className="text-grayscale">
            {t("trajectory:actionPlan.addReductionActions")}
          </Typography>
        </div>
      )}
    </Card>
  );
}

export default ActionsList;
